(function() {
  const trackingLabels = document.querySelectorAll('.pp_tracking_span span');

  trackingLabels.forEach((el) => {
    const inputEl = el.closest('.pp_tracking_parent')?.querySelector('.pp_tracking_input input');

    if (inputEl) {
      inputEl.placeholder = el.textContent;
    }
  });
})();
